import SelectComponent, { SelectOption } from '@Components/Selectors/Select'
import Button from '@Components/Buttons/Button'
import React from 'react'

export const UPDATE_REQUEST_REASONS = {
    writerName: 'writer-name',
    mergeWriters: 'merge-writers',
    createIpi: 'create-ipi',
    updateIpi: 'update-ipi',
} as const

export type SongwriterUpdateRequestReason = (typeof UPDATE_REQUEST_REASONS)[keyof typeof UPDATE_REQUEST_REASONS]

export type SongwriterUpdateRequestReasonOption = Omit<SelectOption, 'value'> & {
    value: SongwriterUpdateRequestReason
}

export const UPDATE_REQUEST_REASON_OPTIONS: SongwriterUpdateRequestReasonOption[] = [
    {
        value: UPDATE_REQUEST_REASONS.writerName,
        label: 'Request to update name',
        id: '1',
    },
    {
        value: UPDATE_REQUEST_REASONS.mergeWriters,
        label: 'Request to merge writer names',
        id: '2',
    },
    {
        value: UPDATE_REQUEST_REASONS.createIpi,
        label: 'Request to add IPI',
        id: '3',
    },
    {
        value: UPDATE_REQUEST_REASONS.updateIpi,
        label: 'Request to update IPI',
        id: '4',
    },
]

interface SelectReasonProps {
    setStep: (step: 'selectReason' | 'form' | 'confirmation') => void
    reason: SongwriterUpdateRequestReasonOption | null
    setReason: (reason: SongwriterUpdateRequestReasonOption | null) => void
}

const SelectReasonStep = (props: SelectReasonProps) => {
    const { setStep, reason, setReason } = props
    return (
        <>
            <h2>Request an update</h2>
            <p>To submit a request to update songwriter information, please answer a few questions below.</p>
            <div>
                <p>Tell us why you're requesting an update:</p>
                <SelectComponent
                    placeholder=""
                    selectedValue={reason}
                    onValueChange={(value) => {
                        setReason(UPDATE_REQUEST_REASON_OPTIONS.find((option) => option.value === value?.value) ?? null)
                    }}
                    options={UPDATE_REQUEST_REASON_OPTIONS}
                />
            </div>
            <Button mainColor type="primary" disabled={!reason} onClick={() => setStep('form')}>
                Next
            </Button>
        </>
    )
}
export default SelectReasonStep
